import { render, staticRenderFns } from "./chart-doughnut-event-type.vue?vue&type=template&id=3c229646"
import script from "./chart-doughnut-event-type.vue?vue&type=script&lang=js"
export * from "./chart-doughnut-event-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports